module.exports = __webpack_public_path__ + "img/non-double.e91d8826.svg";